const FormComponentMixin = {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        columns: {
            type: String,
            default: ''
        },
        uniqueName: {
            type: String,
            default: ''
        },
        maxLength: {
            type: Number,
            default: 100
        }
    },

    data() {
        return { required: false };
    },

    methods: {
        isRequired() {
            const field = this.$parent.$validator.fields.find({
                name: this.name
            });

            if (
                typeof field !== 'undefined' &&
                field.rules.hasOwnProperty('required')
            ) {
                this.required = true;
            } else {
                this.required = false;
            }
        }
    },

    mounted() {
        this.isRequired();
    }
};

export default FormComponentMixin;
